import { render } from "./Anchor.vue?vue&type=template&id=7d4c96de&ts=true"
import script from "./Anchor.vue?vue&type=script&lang=ts"
export * from "./Anchor.vue?vue&type=script&lang=ts"

import "./Anchor.vue?vue&type=style&index=0&id=7d4c96de&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__